"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidAmountAndSessionRequestToJSON = exports.PrepaidAmountAndSessionRequestFromJSONTyped = exports.PrepaidAmountAndSessionRequestFromJSON = exports.instanceOfPrepaidAmountAndSessionRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the PrepaidAmountAndSessionRequest interface.
 */
function instanceOfPrepaidAmountAndSessionRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPrepaidAmountAndSessionRequest = instanceOfPrepaidAmountAndSessionRequest;
function PrepaidAmountAndSessionRequestFromJSON(json) {
    return PrepaidAmountAndSessionRequestFromJSONTyped(json, false);
}
exports.PrepaidAmountAndSessionRequestFromJSON = PrepaidAmountAndSessionRequestFromJSON;
function PrepaidAmountAndSessionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'budgetMicroAmount': !(0, runtime_1.exists)(json, 'budget_micro_amount') ? undefined : json['budget_micro_amount'],
        'successUrl': !(0, runtime_1.exists)(json, 'success_url') ? undefined : json['success_url'],
    };
}
exports.PrepaidAmountAndSessionRequestFromJSONTyped = PrepaidAmountAndSessionRequestFromJSONTyped;
function PrepaidAmountAndSessionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'budget_micro_amount': value.budgetMicroAmount,
        'success_url': value.successUrl,
    };
}
exports.PrepaidAmountAndSessionRequestToJSON = PrepaidAmountAndSessionRequestToJSON;
